
import { Button } from "@/components/ui/button";
import { Link } from "react-router-dom";
import Footer from "@/components/Footer";

interface LoadingPageProps {
  title?: string;
  description?: string;
  actionLabel?: string;
  actionLink?: string;
  isLoading?: boolean;
  startTime?: string;
  showProgressBar?: boolean;
}

const LoadingPage = ({
  title = "Processing Your Report",
  description = "You have successfully provided your data and we are processing your energy report. This can take up to 24 hours due to constrained capacity. You will be notified via email as soon as your report has been completed.",
  actionLabel,
  actionLink,
  isLoading,
  startTime = "10:45 AM",
  showProgressBar = true
}: LoadingPageProps) => {
  return (
    <div className="flex flex-col min-h-screen bg-white border-2 border-[#CED4DA] rounded-lg">
      {/* Main Content */}
      <main className="flex-1 w-full">
        <div className="max-w-7xl mx-auto px-4 py-32">
          <div className="max-w-2xl mx-auto text-center">
            {/* Title */}
            <h1 className="text-3xl font-bold text-gray-900 mb-8">{title}</h1>

            {/* Progress Bar - Only show if showProgressBar is true */}
            {showProgressBar && (
              <div className="w-full h-2 bg-gray-200 rounded-full mb-8">
                <div className="w-3/4 h-full bg-emerald-600 rounded-full opacity-80" />
              </div>
            )}

            {/* Description */}
            <p className="text-lg text-gray-600 mb-8">{description}</p>
          </div>
        </div>
      </main>

      <Footer />
    </div>
  );
};

export { LoadingPage };
